var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionsCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_214_2340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.2302C16.0864 20.2302 20.6151 15.7015 20.6151 10.1151C20.6151 4.52869 16.0864 0 10.5 0C4.91358 0 0.384888 4.52869 0.384888 10.1151C0.384888 15.7015 4.91358 20.2302 10.5 20.2302Z",
    fill: "#FFCE33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 18.2085C14.8926 18.2085 18.4533 14.6479 18.4533 10.2555C18.4533 5.8632 14.8926 2.30252 10.5002 2.30252C6.10792 2.30252 2.54724 5.8632 2.54724 10.2555C2.54724 14.6479 6.10792 18.2085 10.5002 18.2085Z",
    fill: "#F28A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4725 12.2912C11.4725 11.9826 11.3963 11.7404 11.2441 11.565C11.092 11.3891 10.8241 11.2232 10.4416 11.0671C10.0588 10.911 9.70554 10.753 9.38154 10.5926C9.05754 10.4325 8.77819 10.2468 8.54388 10.0362C8.30957 9.82524 8.12979 9.58145 8.00493 9.30407C7.88008 9.0267 7.81765 8.69084 7.81765 8.29651C7.81765 7.63666 8.0401 7.09258 8.4854 6.66505C8.9307 6.23753 9.52418 5.98861 10.2662 5.91827V4.68233H11.1975V5.94159C11.9123 6.04708 12.4734 6.34105 12.8815 6.8231C13.2897 7.30555 13.4936 7.91759 13.4936 8.65963H11.5136C11.5136 8.25344 11.4354 7.9413 11.2793 7.7224C11.1232 7.5039 10.9004 7.39445 10.6116 7.39445C10.3539 7.39445 10.1536 7.47545 10.011 7.63745C9.86833 7.79945 9.7972 8.02309 9.7972 8.30797C9.7972 8.59285 9.87939 8.82637 10.0434 8.99627C10.2073 9.16617 10.4709 9.32817 10.834 9.48227C11.1971 9.63676 11.5397 9.79679 11.8621 9.96274C12.1841 10.1287 12.4627 10.3172 12.697 10.5282C12.9313 10.7392 13.1146 10.9849 13.2478 11.2662C13.3806 11.5476 13.4469 11.8854 13.4469 12.2797C13.4469 12.9475 13.2352 13.4924 12.8112 13.914C12.3872 14.3355 11.8103 14.5817 11.0802 14.652V15.8295H10.1489V14.6461C9.29738 14.556 8.64424 14.2644 8.18946 13.7705C7.73428 13.2766 7.50708 12.6255 7.50708 11.817H9.48111C9.48111 12.2623 9.57949 12.601 9.77705 12.8333C9.97422 13.0656 10.2544 13.1818 10.6175 13.1818C10.883 13.1818 11.092 13.1028 11.2441 12.9447C11.3963 12.7867 11.4725 12.569 11.4725 12.2916V12.2912Z",
    fill: "#FFCE33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_214_2340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2302,
    height: 20.2302,
    fill: "white",
    transform: "translate(0.384888)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsCoin);
export default __webpack_public_path__ + "static/media/actions-coin.1f2a4fed1a0b5053329192ae732462c2.svg";
export { ForwardRef as ReactComponent };